import Layout from '@/layout'

const villageRouter = {
  path: '/register',
  component: Layout,
  children: [
    {
      path: '/order',
      name: 'order',
      meta: {
        title: '订单管理',
      },
      component: () => import('@/views/shop/order.vue'),
    },
    {
      path: '/category',
      name: 'category',
      meta: {
        title: '商品分类',
      },
      component: () => import('@/views/shop/category.vue'),
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      meta: {
        title: '订单评价',
      },
      component: () => import('@/views/shop/evaluate.vue'),
    },
    {
      path: '/sign',
      name: 'sign',
      meta: {
        title: '工作台',
      },
      component: () => import('@/views/signIn/index.vue'),
    },
    {
      path: '/clockIn/:userId/:companyName/:platformId/:companyId',
      name: 'clockIn',
      meta: {
        title: '打卡签到',
      },
      component: () => import('@/views/signIn/clockIn.vue'),
    },
    {
      path: '/clockInInfo/:companyId/:companyName/:platformId/:userId',
      name: 'clockInInfo',
      meta: {
        title: '考勤记录',
      },
      component: () => import('@/views/signIn/clockInInfo.vue'),
    },
    {
      path: '/OA/:userId/:companyName/:platformId/:companyId/:nickName/:deptId',
      name: 'OA',
      meta: {
        title: 'OA审批',
      },
      component: () => import('@/views/signIn/OA.vue'),
    },
    {
      path: '/approvalList/:userId/:platformId/:companyId/:nickName/:status',
      name: 'approvalList',
      meta: {
        title: '审批列表',
      },
      component: () => import('@/views/signIn/approvalList.vue'),
    },
    {
      path: '/approvalDetail/:instanceId/:flag/:activiteId/:userId/:nickName',
      name: 'approvalDetail',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/signIn/approvalDetail.vue'),
    },
    {
      path: '/test',
      name: 'test',
      meta: {
        title: 'test',
      },
      component: () => import('@/views/signIn/test.vue'),
    },
    {
      path: '/approval/:tptId/:userId/:platformId/:companyId/:nickName/:deptId/:labelName',
      name: 'approval',
      meta: {
        title: '发起审批',
      },
      component: () => import('@/views/signIn/approval.vue'),
    },
    {
      path: '/tptGroup',
      name: 'tptGroup',
      meta: {
        title: '模板分组',
      },
      component: () => import('@/views/shop/tptGroup.vue'),
    },
    {
      path: '/globalTpt',
      name: 'globalTpt',
      meta: {
        title: '模板',
      },
      component: () => import('@/views/shop/globalTpt.vue'),
    },
    {
      path: '/staging',
      name: 'staging',
      meta: {
        title: '工作台',
      },
      component: () => import('@/views/shop/staging.vue'),
    },
    {
      path: '/statistics',
      name: 'statistics',
      meta: {
        title: '考勤统计',
      },
      component: () => import('@/views/shop/statistics.vue'),
    },
    {
      path: '/flowInstance',
      name: 'flowInstance',
      meta: {
        title: '全部审批',
      },
      component: () => import('@/views/shop/flowInstance.vue'),
    },
    {
      path: '/clockInLog',
      name: 'clockInLog',
      meta: {
        title: '考勤记录',
      },
      component: () => import('@/views/signIn/clockInLog.vue'),
    },
    {
      path: '/clockStat',
      name: 'clockStat',
      meta: {
        title: '考勤统计',
      },
      component: () => import('@/views/signIn/clockStat.vue'),
    },
    {
      path: '/repairRules',
      name: 'repairRules',
      meta: {
        title: '补卡规则',
      },
      component: () => import('@/views/signIn/repairRules.vue'),
    },
    {
      path: '/myRepairInfo/:companyId/:companyName/:platformId/:userId',
      name: 'myRepairInfo',
      meta: {
        title: '我的补卡记录',
      },
      component: () => import('@/views/signIn/myRepairInfo.vue'),
    },
    {
      path: '/repairExamine/:companyId/:companyName/:platformId/:userId',
      name: 'repairExamine',
      meta: {
        title: '补卡审核',
      },
      component: () => import('@/views/signIn/repairExamine.vue'),
    },
    {
      path: '/registerUser',
      name: 'registerUser',
      meta: {
        title: '设备绑定员工',
      },
      component: () => import('@/views/signIn/registerUser.vue'),
    },

    {
      path: '/inspectionSettings',
      name: 'inspectionSettings',
      meta: {
        title: '巡检点设置',
      },
      component: () => import('@/views/sysInspection/inspectionSettings.vue'),
    },
    {
      path: '/inspectionLog',
      name: 'inspectionLog',
      meta: {
        title: '巡检记录',
      },
      component: () => import('@/views/sysInspection/inspectionLog.vue'),
    },

    {
      path: '/dailyNewspaper',
      name: 'dailyNewspaper',
      meta: {
        title: '日报',
      },
      component: () => import('@/views/workLog/dailyNewspaper.vue'),
    },
    // workOrder
    {
      path: '/workOrder/:companyId/:userId/:phone/:isExamine',
      name: 'workOrder',
      meta: {
        title: '项目管理',
      },
      component: () => import('@/views/signIn/workOrder.vue'),
    },
    {
      path: '/workOrder/:companyId',
      name: 'workOrder',
      meta: {
        title: '项目管理',
      },
      component: () => import('@/views/signIn/workOrder.vue'),
    },
    {
      path: '/workOrderDetails/:id',
      name: 'workOrderDetails',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/signIn/workOrderDetails.vue'),
    },
    {
      path: '/workAddDemand/:companyId/:userId/:phone/:id',
      name: 'workAddDemand',
      meta: {
        title: '添加需求',
      },
      component: () => import('@/views/signIn/workAddDemand.vue'),
    },
    {
      path: '/workAddOrder/:companyId/:userId/:phone/:id',
      name: 'workAddOrder',
      meta: {
        title: '添加子任务',
      },
      component: () => import('@/views/signIn/workAddOrder.vue'),
    },
    {
      path: '/ticketsDetails/:id',
      name: 'ticketsDetails',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/signIn/ticketsDetails.vue'),
    },
    {
      path: '/workTaskDetails/:id',
      name: 'workTaskDetails',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/signIn/workTaskDetails.vue'),
    },
    {
      path: '/workAddConvert/:companyId/:userId/:phone/:id',
      name: 'workAddConvert',
      meta: {
        title: '转为工单',
      },
      component: () => import('@/views/signIn/workAddConvert.vue'),
    },
  ],
}

export default villageRouter
